import React from 'react';
import { Field } from 'formik';

import styles from './metricsFormStyles';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import DocumentsForm from 'buyside/components/presentation/Form/DocumentsForm/documentsForm';

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const MetricsForm = () => {
  return (
    <div>
      <div className={styles.metricsFormMainArea}>
        <Field component={InputField} name="fundProfile.beta" label="Beta" />
        <Field component={InputField} name="fundProfile.sharpeRatio" label="Sharpe Ratio" />
        <Field
          component={InputField}
          name="fundProfile.turnoverRatio"
          label="Turnover Ratio"
          addon="%"
        />
      </div>
      <DocumentsForm
        title="Supporting Documents"
        attr="fundProfile.metricsDocuments"
        withDescription
        withMargin
      />
    </div>
  );
};

export default MetricsForm;
